import { render, staticRenderFns } from "./BusinessInformationPage.vue?vue&type=template&id=06d55ab2"
import script from "./BusinessInformationPage.vue?vue&type=script&lang=js"
export * from "./BusinessInformationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports